import type { FieldErrors } from 'react-hook-form'
import { toast } from '@/components/ui/Toast'

/**
 * Handler padrão para passar como `onError` ao `handleSubmit` do
 * react-hook-form. Mostra um toast amigável avisando que há campos com erro.
 *
 *   form.handleSubmit(onSubmit, onValidationFail)
 *
 * Conta quantos campos têm erro e personaliza a mensagem.
 */
export function onValidationFail(errors: FieldErrors): void {
  const count = countErrors(errors)
  toast.error({
    title: 'Verifique os dados',
    description: count <= 1
      ? 'Há um campo obrigatório não preenchido ou inválido. Revise o campo destacado em vermelho.'
      : `Há ${count} campos com erros. Revise os destacados em vermelho.`,
  })
}

function countErrors(errors: FieldErrors): number {
  let n = 0
  for (const v of Object.values(errors)) {
    if (!v) continue
    if (typeof v === 'object' && 'message' in v) n += 1
    else if (typeof v === 'object') n += countErrors(v as FieldErrors)
  }
  return n
}
